<template>
  <div class="container">
    <div v-if="!samples">
    </div>
    <div v-else class="samples">
      <div v-for="sample in samples" :key="sample.id">
        <div class="sample-container" :class="{ 'card-selected': sample.selected }">
          <SampleCard :date="sample.date" :selected="sample.selected" @keyup.enter="onOpenGenomicsResults(sample)"
            @click.prevent="onOpenGenomicsResults(sample)">
          </SampleCard>
          <div class="checkbox-layer">
            <span v-if="sample.selected" class="material-symbols-outlined size-24 checked"
              @click.prevent="sample.selected = !sample.selected">
              check_circle
            </span>
            <span v-else class="material-symbols-outlined size-24 unchecked"
              @click.prevent="sample.selected = !sample.selected">
              radio_button_unchecked
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineEmits, ref, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { getSamples } from './getSpecimens.js'
import SampleCard from './SampleCard.vue'
import { clearCenterColumn } from '@/ux3/components/CenterColumnManagement/centerColumnManagement.js'

const store = useStore()
const samples = ref([])
const currentlySelectedSample = ref('')

const emit = defineEmits(['count'])

const patientId = computed(() => store.getters.session?.patient?.id || '')
const genomicsResults = computed(() => store.getters.session?.genomicsResults || {})
const isCenterColumnGenomics = computed(() => store.getters.session?.centerColumnState.genomics || false)

const onOpenGenomicsResults = (sample) => {
  // we don't want to reload when we click the same sample card
  if (sample.sample === currentlySelectedSample.value && isCenterColumnGenomics.value) { return }
  currentlySelectedSample.value = sample.sample
  const cardState = {
    sampleId: sample.sample,
    diagnosis: genomicsResults.value.diagnosis || '',
    //specimen type, testType, labName probably need to go here as well

    // clearing values on a new sample , initially. Correctly set elsewhere
    // after loading genomics
    selectedAlteration: '',
    treatmentOrTrialType: 'treatments',
    treatmentOrTrialCount: 0,
  }
  store.dispatch('setGenomicsResults', { genomicsResults: cardState, publish: true })
  clearCenterColumn('genomics')
}

const loadSamples = async (id) => {
  if (!id) { return }

  const results = await getSamples(id)
  results.results.sort(compareDates)

  //presently, what we get back looks like: {results: Array(23)}
  samples.value = results?.results || []

  samples.value.forEach(sample => {
    sample.selected = false
  })

  emit('count', samples.value.length)
}

watch(patientId, () => {
  loadSamples(patientId.value)
})

onMounted(async () => {
  loadSamples(patientId.value)
})

// sort by date descending (newest to oldest)
const compareDates = (a, b) => {
  if (a.date < b.date) {
    return 1
  }
  if (a.date > b.date) {
    return -1
  }
  return 0
}
</script>

<style lang="scss" scoped>
.sample-container {
  position: relative;
}

.checkbox-layer {
  position: absolute;
  top: 15%;
  right: 13%;
  height: 24px;
  width: 24px;

  &:hover {
    cursor: pointer;
  }
}

.checked {
  color: var(--Black);
}

.unchecked {
  color: var(--Grey500);
}
</style>
